<template>
    <widget title="研究工作室-管理员" :router="router" :class="'widget_level'+swWidth">
        <div class="warp_main">
            <div class="count_main">
                <div class="count_item first">
                    <strong>{{pandect.studioAmount || 0}}</strong>
                    <div>在编工作室</div>
                </div>
                <div class="count_item">
                    <span v-if="swWidth == 1"><img src="../img/master/ico3.png"></span>
                    <strong>{{pandect.accessAmount || 0}}</strong>
                    <div>访问总量</div>
                </div>
                <div class="count_item">
                    <span v-if="swWidth == 1"><img src="../img/master/ico1.png"></span>
                    <strong>{{pandect.memberAmount || 0}}</strong>
                    <div>成员总数</div>
                </div>
                <div class="count_item">
                    <span v-if="swWidth == 1"><img src="../img/master/ico4.png"></span>
                    <strong>{{pandect.resourceAmount || 0}}</strong>
                    <div>资源总数</div>
                </div>
                <div class="count_item">
                    <span v-if="swWidth == 1"><img src="../img/master/ico2.png"></span>
                    <strong>{{pandect.activtyAmount || 0}}</strong>
                    <div>活动总数</div>
                </div>
            </div>
            <div class="chart_el" ref="chart_el" style="height:180px" v-if="swWidth != 1"></div>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    export default {
        components: {
            widget
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
        },
        data(){
            return{
                pandect:{
                    studioAmount: 0,
                    memberAmount: 0,
                    activtyAmount: 0,
                    resourceAmount: 0,
                    accessAmount: 0,
                },
                filter: {
                    time: '2',
                    participantType: '',
                },
                router:'master_studio_admin_index'
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                vm.query()
                if(vm.swWidth != 1){
                    vm.lineQuery()
                }
            })
            
        },
        methods:{
            query(){
                let vm = this
                http.get('/gateway/databusiness/masterStudio/all').then(function (xhr) {
                    if(xhr.data.code)return
                    vm.pandect =xhr.data.data;
                })
                
            },
            lineQuery(){
                let vm = this
                let option = {
                        color:['#62e6ca','#ffc271'],
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            right:'10px',
                            data:['浏览次数','独立访客']
                        },
                        grid: {
                            top:'30px',
                            left: '3%',
                            right: '10px',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: ['','周二','周三','周四','周五','周六','周日'],
                            axisLine: {
                                lineStyle: {
                                color: '#007bc6',
                                width:2
                                }
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                color: '#e9eaea'
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                fontSize: 12,
                                color:'#333'
                                }
                            },
                        },
                        yAxis: {
                            type: 'value',
                            name:'最近7天访问量（次）',
                            nameTextStyle:{
                                color:'#333',
                                padding:[0,0,0,60]
                            },
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                color: '#007bc6',
                                width:2
                                }
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                color: '#e9eaea'
                                }
                            },
                            axisLabel: {
                                margin: 10,
                                textStyle: {
                                fontSize: 12,
                                color:'#333'
                                }
                            },
                        },
                        series: [
                            {
                                name:'浏览次数',
                                type:'line',
                                smooth:true,
                                symbol: 'circle',
                                symbolSize: '8',
                                data:[120, 132, 101, 134, 90, 230, 210]
                            },
                            {
                                name:'独立访客',
                                type:'line',
                                smooth:true,
                                symbol: 'circle',
                                symbolSize: '8',
                                data:[220, 182, 191, 234, 290, 330, 310]
                            },
                        ]
                    };
                http.get('/gateway/masterstudio/studioBrowsingHistory/statistics', {params: vm.filter}).then(function (xhr) {  
                    let chartData = xhr.data.data
                    let myChart = echarts.init(vm.$refs["chart_el"])
                    option.xAxis.data = chartData.xAxis
                    option.series[0].data = chartData.pvcount
                    option.series[1].data = chartData.uvcount
                    myChart.setOption(option);
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .count_main:after{
        content: '';
        clear: both;
        display: block;
    }
    .widget_level1{
        .count_item.first{
            width: 100%;
            background: url('../img/master/manage.png') no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-size: 16px;
            height: 66px;
            line-height: 66px;
            padding: 0 24px;
            margin-top:20px;
            strong{
                font-size: 24px;
                float: right;
            }
            div{
                color: #fff;
            }
        }
        .count_item{
            float: left;
            width: 50%;
            margin-top: 30px;
            span{
                width: 48px;
                height: 48px;
                line-height: 48px;
                text-align: center;
                float: left;
                border-radius: 50%;
                margin-right: 10px;
                img{
                    vertical-align: middle;
                }
            }
            div{
                color: #666;
            }
            strong{
                margin-top: 5px;
                display: block;
            }
        }
        .count_item:nth-child(2){
            span{
                background: -webkit-linear-gradient(bottom,#ebed0e, #f8922d);
                background: -o-linear-gradient(bottom,#ebed0e, #f8922d);
                background: -moz-linear-gradient(bottom,#ebed0e, #f8922d);
                background: linear-gradient(to bottom,#ebed0e, #f8922d);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ebed0e', endColorstr='#f8922d', GradientType=1);
            }
            strong{
                color:#f8922d;
            }
        }
        .count_item:nth-child(3){
            span{
                background: -webkit-linear-gradient(bottom,#24eaa7, #02cef1);
                background: -o-linear-gradient(bottom,#24eaa7, #02cef1);
                background: -moz-linear-gradient(bottom,#24eaa7, #02cef1);
                background: linear-gradient(to bottom,#24eaa7, #02cef1);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#24eaa7', endColorstr='#02cef1', GradientType=1);
            }
            strong{
                color:#02cef1;
            }
        }
        .count_item:nth-child(4){
            span{
                background: -webkit-linear-gradient(bottom,#ff76b3, #d335f3);
                background: -o-linear-gradient(bottom,#ff76b3, #d335f3);
                background: -moz-linear-gradient(bottom,#ff76b3, #d335f3);
                background: linear-gradient(to bottom,#ff76b3, #d335f3);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff76b3', endColorstr='#d335f3', GradientType=1);
            }
            strong{
                color:#d335f3;
            }
        }
        .count_item:nth-child(5){
            span{
                background: -webkit-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: -o-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: -moz-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: linear-gradient(to bottom,#ecec0f, #26e9a6);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ecec0f', endColorstr='#26e9a6', GradientType=1);
            }
            strong{
                color:#26e9a6;
            }
        }
    }
    .widget_level2,
    .widget_level3{
        .count_main{
            margin-top: 15px;
        }
        .count_item{
            box-sizing: border-box;
            float: left;
            width: calc(~'20% - 16px');
            margin-left: 20px;
            border-radius: 8px;
            background: #3ab4fb;
            color: #fff;
        }
        .count_item:first-child{
            margin-left: 0;
        }
    }
    .widget_level2{
        .chart_el{
            margin-top: 15px;
        }
        .count_item{
            text-align: center;
            padding: 11px 15px;
             strong{
                 font-size: 18px;
             }
        }
    }
    .widget_level2{
        .count_item:nth-child(1){
            background: -webkit-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: -o-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: -moz-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: linear-gradient(to bottom,#3bb7fb, #1965f0);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3bb7fb', endColorstr='#1965f0', GradientType=1);
        }
        .count_item:nth-child(2){
            background: -webkit-linear-gradient(bottom,#ebed0e, #f8922d);
            background: -o-linear-gradient(bottom,#ebed0e, #f8922d);
            background: -moz-linear-gradient(bottom,#ebed0e, #f8922d);
            background: linear-gradient(to bottom,#ebed0e, #f8922d);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ebed0e', endColorstr='#f8922d', GradientType=1);
        }
        .count_item:nth-child(3){
            background: -webkit-linear-gradient(bottom,#24eaa7, #02cef1);
            background: -o-linear-gradient(bottom,#24eaa7, #02cef1);
            background: -moz-linear-gradient(bottom,#24eaa7, #02cef1);
            background: linear-gradient(to bottom,#24eaa7, #02cef1);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#24eaa7', endColorstr='#02cef1', GradientType=1);
        }
        .count_item:nth-child(4){
            background: -webkit-linear-gradient(bottom,#ff76b3, #d335f3);
            background: -o-linear-gradient(bottom,#ff76b3, #d335f3);
            background: -moz-linear-gradient(bottom,#ff76b3, #d335f3);
            background: linear-gradient(to bottom,#ff76b3, #d335f3);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff76b3', endColorstr='#d335f3', GradientType=1);
        }
        .count_item:nth-child(5){
            background: -webkit-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: -o-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: -moz-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: linear-gradient(to bottom,#ecec0f, #26e9a6);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ecec0f', endColorstr='#26e9a6', GradientType=1);
        }
        .count_item:nth-child(6){
            background: -webkit-linear-gradient(bottom,#af6fff, #5659f8);
            background: -o-linear-gradient(bottom,#af6fff, #5659f8);
            background:  -moz-linear-gradient(bottom,#af6fff, #5659f8);
            background: linear-gradient(to bottom,#af6fff, #5659f8);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#af6fff', endColorstr='#5659f8', GradientType=1);
        }
    }
    .widget_level3{
        .chart_el{
            margin-top: 12px;
        }
        .count_item{
            font-size: 12px;
            padding: 15px;
            strong{
                float: right;
                line-height: 40px;
                font-size: 18px;
            }
        }
        .count_item:nth-child(1){
            background: url(../img/master/01.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(2){
            background: url(../img/master/02.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(3){
            background: url(../img/master/03.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(4){
            background: url(../img/master/04.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(5){
            background: url(../img/master/05.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(6){
            background: url(../img/master/06.png) no-repeat;
            background-size: 100% 100%;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/homepage/widget/manage.vue